/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'ptc.pm.collaborators.title': '내 공동 작업자',
  'ptc.pm.error-heading': '오류가 발생했습니다.',
  'ptc.pm.error-image-alt-text': '고장난 로봇과 고치느라 바쁜 몇 명의 사람입니다.',
  'ptc.pm.error-text':
    '이러한 오류를 계속 추적하지만, 페이지를 새로 고친 후에도 문제가 해결되지 않으면 언제든지 문의해 주세요.',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number}명 구성원}}',
  'ptc.pm.people': '사용자',
  'ptc.pm.teams': '팀',
  'ptc.pm.view-your-profile': '내 프로필 보기',
  'ptc.pm.your-teams.title': '내 팀',
};
